import { HttpErrorResponse } from '@angular/common/http';

import type { JobTemplateBrief } from '@recruitee/job-templates-types';
import {
  createEntityCollectionStore,
  getEntityCollectionActions,
  ngrxEvent,
} from '@recruitee/ngrx';

const { actions, namespace, selectors, reducer } = createEntityCollectionStore<JobTemplateBrief>()(
  'JobTemplates',
  {
    customActions: adapter => {
      const defaultActions = getEntityCollectionActions(adapter, ({ id }) => id!);

      return {
        createOnePessimistic: (
          state,
          payload: {
            correlationId: string;
            data: {
              name: string;
              primaryLangCode?: string;
            };
          },
        ) => adapter.markAsPending(state),
        duplicate: ngrxEvent<{ id: number }>(),
        duplicateSuccess: (state, payload: { offerTemplate: JobTemplateBrief }) =>
          adapter.addOne(state, payload.offerTemplate),
        duplicateFailed: ngrxEvent<{
          id: number;
          error: HttpErrorResponse & { errorFields: any };
        }>(),
        delete: defaultActions.removeOnePessimistic,
        deleteSuccess: defaultActions.removeOnePessimisticSuccess,
        deleteFailed: defaultActions.removeOnePessimisticFailed,
      };
    },
  },
);

export {
  actions as JobTemplatesActions,
  namespace as JobTemplatesNamespace,
  reducer as JobTemplatesReducer,
  selectors as JobTemplatesSelectors,
};
